import React from 'react';
import PropTypes from 'prop-types';

export default function NewsCard({ item, onClick }) {
  const bgColor = item.Title_Background_Color || '#03a0eb';
  const textColor = item.Title_Color || '#ffffff';

  const formattedDate = item.Date
    ? new Date(item.Date + 'T12:00:00').toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      })
    : '';

  return (
    <button
      type='button'
      className='flex h-full w-full flex-col cursor-pointer rounded-xl border border-white text-left transition-shadow bg-transparent'
      onClick={() => onClick(item)}
    >
      <div
        className='flex-1 rounded-t-xl px-3 py-4 text-center'
        style={{
          background: `linear-gradient(135deg, ${bgColor} 0%, ${bgColor}99 100%)`
        }}
      >
        <p
          className='m-0 mb-1 text-xs font-semibold uppercase tracking-widest'
          style={{ color: textColor }}
        >
          {item.Name}
        </p>
        <p className='m-0 text-lg font-bold' style={{ color: textColor }}>
          {formattedDate}
        </p>
        {item.Priority === 1 && (
          <span
            className='mt-2 inline-block rounded-full px-2 py-0.5 text-xs font-medium'
            style={{ color: textColor, backgroundColor: `${textColor}40` }}
          >
            Latest Issue
          </span>
        )}
      </div>
      <div className='rounded-b-xl bg-gray-100 p-3'>
        <p className='m-0 line-clamp-2 text-sm text-gray-600'>
          {item.News_Summary}
        </p>
      </div>
    </button>
  );
}

NewsCard.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string,
    Name: PropTypes.string,
    Date: PropTypes.string,
    News_Summary: PropTypes.string,
    HTML_Content: PropTypes.string,
    Image_URL: PropTypes.string,
    Priority: PropTypes.number,
    Title_Color: PropTypes.string,
    Title_Background_Color: PropTypes.string
  }).isRequired,
  onClick: PropTypes.func.isRequired
};
